export const CTCActions = {
  PEP_OK: "PEP_OK",
  INGRESO_OK: "INGRESO_OK",
  CTC_STEP_ONE_OK: "CTC_STEP_ONE_OK",
  STEP_TWO_OK: "STEP_TWO_OK",
  FIRMA_OK: "FIRMA_OK",
  FIRMA_SVG: "FIRMA_SVG",
  CEDULA_PASAPORTE: "CEDULA_PASAPORTE",
  KYC_DT_PART_OK: "KYC_DT_PART_OK",
  KYC_PART_1_OK: "KYC_PART_1_OK",
  KYC_PART_2_OK: "KYC_PART_2_OK",
  KYC_PART_3_OK: "KYC_PART_3_OK",
  KYC_ENDPOINT_RESPONSE: "KYC_ENDPOINT_RESPONSE",
  GENERATE_SOLICITUD_N_CHECKLIST_DATA: "GENERATE_SOLICITUD_N_CHECKLIST_DATA",
  CHECK_TRAFFIC_HISTORY_RES: "CHECK_TRAFFIC_HISTORY_RES",

  setPepOK: (pep_ok) => {
    return (dispatch) => {
      dispatch({
        type: CTCActions.PEP_OK,
        pep_ok,
      });
    };
  },
  setIngresoOK: (ingreso_ok) => {
    return (dispatch) => {
      dispatch({
        type: CTCActions.INGRESO_OK,
        ingreso_ok,
      });
    };
  },
  setCTCStepOneOk: (ctc_step_one_ok) => {
    return (dispatch) => {
      dispatch({
        type: CTCActions.CTC_STEP_ONE_OK,
        ctc_step_one_ok,
      });
    };
  },
  setCTCstepTwo: (ctc_step_two_ok) => {
    return (dispatch) => {
      dispatch({
        type: CTCActions.STEP_TWO_OK,
        ctc_step_two_ok,
      });
    };
  },
  setFirmaOK: (firma_ok) => {
    return (dispatch) => {
      dispatch({
        type: CTCActions.FIRMA_OK,
        firma_ok,
      });
    };
  },
  setFirma: (firma_svg) => {
    return (dispatch) => {
      dispatch({
        type: CTCActions.FIRMA_SVG,
        firma_svg,
      });
    };
  },
  selectCedulaPasaporte: (valor) => {
    return (dispatch) => {
      const selectCedulaPas = valor;
      dispatch({
        type: CTCActions.CEDULA_PASAPORTE,
        selectCedulaPas,
      });
    };
  },
  setKYCDTPartOK: (kyc_dt_part_ok) => {
    return (dispatch) => {
      dispatch({
        type: CTCActions.KYC_DT_PART_OK,
        kyc_dt_part_ok,
      });
    };
  },
  setKYCPart1OK: (kyc_part_1_ok) => {
    return (dispatch) => {
      dispatch({
        type: CTCActions.KYC_PART_1_OK,
        kyc_part_1_ok,
      });
    };
  },
  setKYCPart2OK: (kyc_part_2_ok) => {
    return (dispatch) => {
      dispatch({
        type: CTCActions.KYC_PART_2_OK,
        kyc_part_2_ok,
      });
    };
  },
  setKYCPart3OK: (kyc_part_3_ok) => {
    return (dispatch) => {
      dispatch({
        type: CTCActions.KYC_PART_3_OK,
        kyc_part_3_ok,
      });
    };
  },
  setKYCEndpointResponse: (kyc_endpoint_response) => {
    return (dispatch) => {
      dispatch({
        type: CTCActions.KYC_ENDPOINT_RESPONSE,
        kyc_endpoint_response,
      });
    };
  },
  setGenerateSolicitudNChecklistData: (generate_solicitud_n_checklist_data) => {
    return (dispatch) => {
      dispatch({
        type: CTCActions.GENERATE_SOLICITUD_N_CHECKLIST_DATA,
        generate_solicitud_n_checklist_data,
      });
    };
  },
  setCheckTrafficHistoryRes: (check_traffic_history_res) => {
    return (dispatch) => {
      dispatch({
        type: CTCActions.CHECK_TRAFFIC_HISTORY_RES,
        check_traffic_history_res,
      });
    };
  },
};
